import React, { Component } from "react";
import Checkbox from "material-ui/Checkbox";
import { CircleIcons, muiLabelStyle } from "ui-components";

import SuggestedTipEditor from "./SuggestedTipEditor";
import {
  AppendixTipWrapper,
  AppendixTipText,
  AppendixSuggestedTipContent,
  TipEditButton
} from "./styled";

class AppendixSuggestedTip extends Component {
  constructor(props) {
    super(props);

    this.state = {
      isEditing: false
    };
  }

  /**
   * Toggle whether the suggested tip is being edited
   * @param  {boolean} isEditing Whether the suggested tip is being edited
   */
  toggleEditing = isEditing => {
    this.setState({
      isEditing
    });
  };

  /**
   * Allow the user to update custom suggested tips
   * @param  {boolean} isCustom Whether the suggested tip is custom
   * @return {object}           Rendered Edit link
   */
  renderEditLink = isCustom => {
    if (isCustom) {
      return (
        <TipEditButton onClick={() => this.toggleEditing(true)}>
          Edit
        </TipEditButton>
      );
    }
  };

  /**
   * Display suggested tip text and references to Appendix section (if they exist)
   * @param  {boolean} isCustom   Whether suggested tip is custom
   * @param  {string}  tipText    Suggested tip text
   * @param  {array}   references List of appendix section references
   * @return {object}             Rendered suggested tip content
   */
  renderTipText = (isCustom, tipText, references) => {
    if (isCustom || references.length === 0) {
      return <span>{tipText}</span>;
    }

    const referencesText = references.join(", ");

    return <span>{tipText} <em>({referencesText})</em></span>;
  };

  render() {
    const {
      children,
      references,
      tipInfo,
      isChecked,
      isCustom,
      onClick
    } = this.props;
    const { EmptyCircle, CheckedCircle, SolidCircle } = CircleIcons;

    // Display toggleable Suggested Tip with Edit link
    if (!this.state.isEditing) {
      return (
        <AppendixTipWrapper>
          <AppendixSuggestedTipContent isReadonly={!isCustom} onClick={onClick}>
            <Checkbox
              checked={isChecked}
              disableTouchRipple
              labelStyle={muiLabelStyle}
              style={{ width: "initial" }}
              iconStyle={{ height: "18px", marginRight: "5px" }}
              uncheckedIcon={<EmptyCircle />}
              checkedIcon={isCustom ? <CheckedCircle /> : <SolidCircle />}
            />
            <AppendixTipText size={5} isBold={isChecked && isCustom}>
              {this.renderTipText(isCustom, children, references)}
            </AppendixTipText>
          </AppendixSuggestedTipContent>
          {this.renderEditLink(isCustom)}
        </AppendixTipWrapper>
      );
    }

    // Display editable Suggested Tip
    return (
      <AppendixTipWrapper>
        <SuggestedTipEditor
          tipInfo={tipInfo}
          initialValue={children}
          toggleEditing={this.toggleEditing}
          upsertSuggestedTip={this.props.upsertSuggestedTip}
          deleteSuggestedTip={this.props.deleteSuggestedTip}
          isEditing
        />
      </AppendixTipWrapper>
    );
  }
}

export default AppendixSuggestedTip;



// WEBPACK FOOTER //
// ./src/common/components/AppendixDialog/AppendixSuggestedTip.jsx